import { Layout as RALayout, CheckForApplicationUpdate } from "react-admin";
import CustomSidebar from "./sidebar";
import CustomAppBar from "./appbar";
import Menu from "./menu";

const Layout = ({ children, props }) => (
  <RALayout
    {...props}
    sidebar={CustomSidebar}
    appBar={CustomAppBar}
    menu={Menu}>
    {children}
    <CheckForApplicationUpdate />
  </RALayout>
);

export default Layout;
